import React from "react";
import { Link } from "react-router-dom";

const SuccessOrder = () => {
  return (
    <section className="successOrder">
      <main className="successOrderMain">
        <h1>Order Confirmed</h1>
        <p>Order Placed Successfully, You can check order status below</p>
        <Link to="/myorders">Check Status</Link>
      </main>
    </section>
  );
};

export default SuccessOrder;
